// Declare resize timer

// Init Flickity
// var elem = document.querySelector('.strap-finder__straps-container');
// var flkty;

// if (elem) {
//     flkty = new Flickity(elem, {
//         cellAlign: "center",
//         contain: false,
//         pageDots: true,
//         draggable: true,
//         touchVerticalScroll: false,
//         prevNextButtons: true,
//         wrapAround: true,
//         imagesLoaded: true, // ✅ critical for iOS

//         on: {
//             ready: function () {
//                 this.resize();
//                 updateOverlay();
//                 setTimeout(() => {
//                     hideLoader();
//                 }, 300);
//             },
//             change: function () {
//                 updateOverlay();
//             },
//             settle: function () {
//                 updateOverlay();
//             }
//         }
//     });
// }
// Declare resize timer
let resizeTimer;

// Store all Flickity instances
let flktyInstances = [];

// Loader
const loader = document.querySelector('.jsc-page-loader');

// Init Flickity for all carousels
document.addEventListener("DOMContentLoaded", function () {

    const elems = document.querySelectorAll('.strap-finder__straps-container');

    elems.forEach(function (elem) {
        const flkty = new Flickity(elem, {
            cellAlign: "center",
            contain: false,
            pageDots: true,
            draggable: true,
            touchVerticalScroll: false,
            prevNextButtons: true,
            wrapAround: true,
            imagesLoaded: true,
            on: {
                ready: function () {
                    this.resize();
                    updateOverlay(this.element);

                    setTimeout(() => {
                        hideLoader();
                    }, 300);
                },

                change: function () {
                    updateOverlay(this.element);
                },

                settle: function () {
                    updateOverlay(this.element);
                }
            }
        });

        flktyInstances.push(flkty);
    });

    // URL param image
    const params = new URLSearchParams(window.location.search);
    const image = params.get("image");

    if (image) {
        document.querySelectorAll(".watch-face").forEach(function (watchFace) {
            watchFace.src = image;
        });
    }

});

// Update overlay height for a specific carousel
function updateOverlay(carousel) {

    if (!carousel) return;

    const selectedImg = carousel.querySelector('.columns.is-selected img.sf-top-strap');

    if (!selectedImg) return;

    // Wait until image is loaded (Safari/iPhone fix)
    if (!selectedImg.complete) {
        selectedImg.onload = function () {
            updateOverlay(carousel);
        };
        return;
    }

    const totalH = selectedImg.offsetHeight;

    if (totalH > 0) {

        // Find the nearest watch-face related to this carousel
        const wrapper = carousel.closest('.strap-finder') || carousel.parentElement;

        if (!wrapper) return;

        const watchFace = wrapper.querySelector('.watch-face');

        if (watchFace) {
            watchFace.style.setProperty('height', totalH + 'px', 'important');
        }
    }
}

// Resize handler
window.addEventListener('resize', function () {

    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {

        flktyInstances.forEach(function (flkty) {
            flkty.resize();
            updateOverlay(flkty.element);
        });

    }, 200);

});

// After page load
window.addEventListener('load', function () {

    flktyInstances.forEach(function (flkty) {
        flkty.resize();
        flkty.reposition();
        updateOverlay(flkty.element);
    });

    setTimeout(() => {
        hideLoader();
    }, 1000);

});

// URL param image
document.addEventListener("DOMContentLoaded", function () {
    const params = new URLSearchParams(window.location.search);
    const image = params.get("image");

    if (image) {
        const targetImg = document.querySelector(".watch-face");

        if (targetImg) {
            targetImg.src = image;
        }
    }
});

// Hide loader
function hideLoader() {

    if (!loader) return;

    loader.classList.add('hide');

    setTimeout(() => {
        loader.style.display = 'none';
    }, 400);

}